export const OPTIONS_FREQUENCY = [
	{ label: 'Daily', value: 'date' },
	{ label: 'Weekly (Mondays)', value: 'week' },
	{ label: 'Execute Now', value: 'now' }
]

export const STOCK_STATUS = [
	{ label: 'Stock', value: 'stock' },
	{ label: 'Click And Collect', value: 'click-and-collect' },
	{ label: 'Out of Stock', value: 'out-of-stock' },
	{ label: 'Deslisted', value: 'deslisted' },
	{ label: 'New Listed', value: 'new-listed' },
	{ label: 'Not Listed', value: 'not-listed' },
	{ label: 'Not Launched', value: 'not-launched' }
]

export const OPTIONS_STREET_DATE = [
	{ label: 'In the past', value: 'past' },
	{ label: 'In the future', value: 'future' },
]